<template>
  <div class="main">
    <div class="AppWhite">
      <div class="AppWhite-main">
        <module-title title="白名单">
          <div class="right">
            <el-button
              type="primary"
              size="medium"
              @click="deleteAddApplication(2)"
            >
              批量删除
            </el-button>
            <el-button
              type="primary"
              size="medium"
              @click="opAdd('batch')"
            >
              批量添加
            </el-button>
            <el-button
              type="primary"
              size="medium"
              @click="opAdd('single')"
            >
              单个添加
            </el-button>
            <el-button type="primary" size="medium" icon="el-icon-arrow-left" @click="$emit('back')">
              返回
            </el-button>
          </div>
        </module-title>
        <div class="AppWhite-main-contain">
          <el-form ref="searchForm" :model="searchForm" :rules="searchFormRules" :inline="true" label-position="right" label-width="100px">
            <el-form-item label="创建时间：" prop="dateTime">
              <el-date-picker
                v-model="searchForm.dateTime"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="dateChange"
              />
            </el-form-item>
            <el-form-item label="设备SN号：" prop="deviceNo">
              <el-input
                v-model="searchForm.deviceNo"
                name="name"
                placeholder="请输入设备SN号"
              />
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                size="medium"
                icon="el-icon-search"
                @click="handleSearchFilter"
              >
                查询
              </el-button>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                size="medium"
                @click="resetInput"
              >
                重置
              </el-button>
            </el-form-item>
          </el-form>
          <el-table
            v-loading="listLoading"
            :data="applicationList"
            highlight-current-row
            fit
            element-loading-text="Loading"
            class="list-table"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="30" />
            <el-table-column type="index" width="55" align="center" label="序号" />
            <el-table-column label="设备SN号" prop="deviceNo" align="center" />
            <el-table-column label="创建时间" prop="createDate" align="center" />
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="mini"
                  @click="deleteAddApplication(1 , scope.row)"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <pagination
            :total="searchForm.total"
            :page.sync="searchForm.pageNum"
            :limit.sync="searchForm.pageSize"
            @pagination="pageCurriculumList"
            @handleSizeChange="handleSizeChange"
          />
        </div>
      </div>
      <!-- 新增白名单 -->
      <el-dialog
        v-if="hiddenVariable.dialogEditVisible"
        :close-on-click-modal="false"
        :visible.sync="hiddenVariable.dialogEditVisible"
        title="新增白名单"
        width="700px"
        @close="handleDialogClose"
      >
        <el-form
          ref="addApplicationForm"
          :model="addApplicationForm"
          :rules="handleRules"
          label-position="right"
          label-width="150px"
        >
          <el-form-item label="设备SN号：" prop="deviceNo">
            <el-input
              v-model="addApplicationForm.deviceNo"
              placeholder="请输入设备SN号"
              name="code"
              class="handle-form-input"
            />
            <el-tooltip
              class="item"
              effect="dark"
              content="输入的单SN号不超过20个字符（可输入20个字符）"
              placement="right"
            >
              <span>
                <img width="30px" class="tips-img" src="@/assets/img/tips.png" alt="">
              </span>
            </el-tooltip>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button
            size="medium"
            @click="hiddenVariable.dialogEditVisible = false"
          >
            取消
          </el-button>
          <el-button
            :loading="ajaxLoading"
            type="primary"
            size="medium"
            @click="handleAddUpgrade"
          >
            {{ ajaxLoading ? 'Loading' : '确定' }}
          </el-button>
        </div>
      </el-dialog>
      <el-dialog
        v-if="hiddenVariable.dialogUploadVisiblePackage"
        :close-on-click-modal="false"
        :visible.sync="hiddenVariable.dialogUploadVisiblePackage"
        title="批量导入"
        width="540px"
      >
        <el-form
          label-position="right"
        >
          <el-form-item style="textAlign:center">
            <el-button type="primary" style=" margin-bottom: 20px;vertical-align: top" icon="el-icon-upload2" size="medium" @click="handlerExcelTemplate">
              下载模板
            </el-button>
            <el-upload
              ref="upload"
              :on-success="onSuccess"
              :action="uploadUrl"
              :headers="uploadHeader"
              :on-progress="onProgress"
              :on-error="onError"
              :multiple="false"
              :limit="1"
              name="file"
              accept=".xls, .xlsx"
              class="handle-btn"
            >
              <el-button
                :loading="hiddenVariable.fileUploading"
                size="medium"
                type="primary"
                icon="el-icon-upload2"
              >
                {{ hiddenVariable.fileUploading?'上传文件中...':'上传文件' }}
              </el-button>
            </el-upload>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- 批量导入异常 -->
      <el-dialog
        :close-on-click-modal="false"
        :visible.sync="hiddenVariable.dialogMultipleImportVisible"
        title="异常数据"
      >
        <p style="padding:0 0 20px 20px;">
          导入失败，存在{{ abnormalDataList.length }}条异常记录，请修改后重新上传
        </p>
        <el-scrollbar wrap-class="abnormal-table">
          <el-table
            :data="abnormalDataList"
            fit
            highlight-current-row
          >
            <el-table-column type="index" width="55" align="center" label="序号" />
            <el-table-column label="异常原因" prop="errorMsg" align="center">
              <template slot-scope="scope">
                <span style="color:red">{{ scope.row.errorMsg }}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-scrollbar>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { getToken } from '@/utils/auth';
import { validateDeviceSn, validateDatePicker } from '@/utils/validate';
import { getWhitesList, whitesAdd, whitesDelete, getAppWhitesResourceDefautExport, getAppWhitesResourceDefautImport } from '@/api/systemMaintenance/upgradeManage/appWhites.js';
import { deepCopy } from '@/utils/index.js';
export default {
  name: 'AppWhite',
  data() {
    // SN号新增
    const validateDeviceSnAdd = (rule, value, callback) => {
      const pattern = new RegExp(/^[\d\s-_*]+$|^[A-Za-z\s\d-_*]+$/);
      if (!value) callback(new Error('课桌SN号不能为空'));
      if (!pattern.test(value)) {
        callback(new Error('请输入数字或字母字符'));
      } else if (value.toString().length > 20) {
        callback(new Error('请输入20以内的字符'));
      } else {
        callback();
      }
    };
    return {
      ajaxLoading: false,
      // 所有控制显示隐藏变量
      hiddenVariable: {
        dialogEditVisible: false,
        dialogUploadVisiblePackage: false,
        fileUploading: false, // 文件上传加载
        dialogMultipleImportVisible: false
      },
      // 搜索表单
      searchForm: {
        pageNum: 1,
        total: 0,
        pageSize: 10,
        deviceNo: '',
        startCreateDate: null,
        endCreateDate: null,
        dateTime: ''
      },
      abnormalDataList: [],
      addApplicationForm: { deviceNo: '', type: 1 },
      listLoading: false, // 表格刷新loading
      applicationList: [],
      multipleSelection: [],
      uploadUrl: '', // 上传文件URL
      uploadHeader: {},
      handleRules: {
        deviceNo: [{ required: true, validator: validateDeviceSnAdd, trigger: 'blur' }]
      },
      searchFormRules: {
        dateTime: [{ trigger: 'change', validator: validateDatePicker }],
        deviceNo: [{ validator: validateDeviceSn, trigger: 'blur' }]
      }
    };
  },
  mounted() {
    this.fetchApplicationList();
    this.initUploadData();
  },
  methods: {
    // 初始化上传数据
    initUploadData() {
      const accessToken = getToken();
      this.uploadHeader = {
        Authorization: `Bearer ${accessToken}`
      };
      this.uploadUrl = getAppWhitesResourceDefautImport({ 'type': 1 }); // 导入
    },
    // 分页
    pageCurriculumList(obj) {
      this.searchForm.pageNum = obj.page;
      this.fetchApplicationList();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = obj.limit;
      this.fetchApplicationList();
    },
    // 重置
    resetInput() {
      this.searchForm = { ...this.searchForm, dateTime: '', deviceNo: '', startCreateDate: null, endCreateDate: null };
      this.fetchApplicationList();
    },
    dateChange(e) {
      if (e) {
        this.searchForm.startCreateDate = e[0];
        this.searchForm.endCreateDate = e[1];
      } else {
        this.searchForm.startCreateDate = null;
        this.searchForm.endCreateDate = null;
      }
    },
    // 条件查询
    handleSearchFilter() {
      if (this.searchForm.dateTime || this.searchForm.deviceNo) {
        this.$refs['searchForm'].validate((valid) => {
          if (valid) {
            this.searchForm.pageNum = 1;
            this.searchForm.pageSize = 10;
            this.fetchApplicationList();
          }
        });
      } else {
        this.searchForm.pageNum = 1;
        this.searchForm.pageSize = 10;
        this.fetchApplicationList();
      }
    },
    // 打开新增编辑弹框
    opAdd(type) {
      if (type === 'batch') {
        this.hiddenVariable.dialogUploadVisiblePackage = true;
      } else {
        this.handleDialogClose();
        this.hiddenVariable.dialogEditVisible = true;
      }
    },
    // type 1 新增白名单弹框 2 批量导入弹框
    handleDialogClose() {
      this.addApplicationForm = { deviceNo: '', type: 1 };
    },
    // 新增白名单
    handleAddUpgrade() {
      this.$refs['addApplicationForm'].validate((valid) => {
        if (valid) {
          this.ajaxLoading = true;
          whitesAdd(this.addApplicationForm)
            .then((result) => {
              this.$notify.success({
                title: 'Success',
                message: '添加成功',
                showClose: false,
                duration: 2000
              });
              this.ajaxLoading = false;
              this.hiddenVariable.dialogEditVisible = false;
              this.fetchApplicationList();
            })
            .catch((err) => {
              console.log(err);
              this.ajaxLoading = false;
            });
        } else {
          console.log('error submit!!');
          this.ajaxLoading = false;
          return false;
        }
      });
    },
    // 删除应用
    deleteAddApplication(type, row) {
      if (type === 2 && this.multipleSelection.length === 0) return;
      this.$confirm(`您确定删除数据吗？`, '删除数据', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => whitesDelete({ type: 1, ids: type === 1 ? row.id : this.multipleSelection.toString() }))
        .then((res) => {
          this.$notify.success({
            title: 'Success',
            message: '删除成功',
            showClose: false,
            duration: 2000
          });
          this.fetchApplicationList();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取应用列表
    fetchApplicationList() {
      this.listLoading = true;
      this.searchForm.type = 1;
      const op = deepCopy(this.searchForm);
      delete op.dateTime;
      getWhitesList(op)
        .then((result) => {
          this.applicationList = result.data.list;
          this.searchForm.total = result.data.total;
          this.listLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.listLoading = false;
          this.applicationList = [];
          this.searchForm.total = 0;
        });
    },
    // 多选
    handleSelectionChange(val) {
      this.multipleSelection = val.map((item) => item.id);
    },
    // 下载模板
    handlerExcelTemplate() {
      window.location.href = getAppWhitesResourceDefautExport();
    },
    // 导入上传成功
    onSuccess(response, file, fileList) {
      this.hiddenVariable.fileUploading = false;
      this.$refs.upload.clearFiles();
      if (response.code === '0') {
        this.$message({
          message: '文件上传成功',
          type: 'success'
        });
        this.fetchApplicationList();
        this.hiddenVariable.dialogUploadVisiblePackage = false;
      } else {
        if (response.data) {
          this.hiddenVariable.dialogMultipleImportVisible = true;
          this.abnormalDataList = [];
          const list = response.data;
          list.forEach(v => {
            this.abnormalDataList.push({ errorMsg: v });
          });
        } else {
          this.$message({
            message: response.message,
            type: 'error'
          });
          this.abnormalDataList = [];
        }
      }
    },
    // 导入 加载
    onProgress() {
      this.hiddenVariable.fileUploading = true;
    },
    onError() {
      this.hiddenVariable.fileUploading = false;
      this.$message({
        message: '文件上传失败',
        type: 'error'
      });
    }
  }
};
</script>
<style lang="scss">
.AppWhite {
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
  .dialog-footer {
      text-align: center;
  }
}
</style>
<style lang="scss" scoped>
.AppWhite {
  padding-bottom: 20px;
  .el-date-editor.el-input {
    margin-left: 20px;
  }
  .handle-form-input {
    width: 80%;
  }
}
.tips-img{
  position: absolute;
  top: 2px;
  right: 65px;
  cursor: pointer;
}
</style>
